// Converts admin-corev2's key-value csvTemplate ("0.field,value\n0.field2,value2")
// to the column-header format consumed by the share-data form ("field,field2\nvalue,value2").
// Mirrors normalizeToColumnHeaderCSV in dex-monorepo/be/producer/internal/service/get_latest_active_version.go.
function normalizeKeyValueCSV(csvTemplate) {
	if (!csvTemplate || typeof csvTemplate !== 'string') return ''

	const headers = []
	const values = []

	for (const line of csvTemplate.split('\n')) {
		if (!line.trim()) continue
		const commaIdx = line.indexOf(',')
		if (commaIdx === -1) continue

		let rawKey = line.slice(0, commaIdx)
		const value = line.slice(commaIdx + 1)

		const dotIdx = rawKey.indexOf('.')
		if (dotIdx !== -1) {
			const prefix = rawKey.slice(0, dotIdx)
			if (/^\d+$/.test(prefix)) {
				rawKey = rawKey.slice(dotIdx + 1)
			}
		}

		headers.push(rawKey)
		values.push(value)
	}

	return `${headers.join(',')}\n${values.join(',')}`
}

export { normalizeKeyValueCSV }
